import React from 'react';
import { IStepProps } from './step.models';

export function Step({ children }: React.PropsWithChildren<IStepProps>): React.ReactElement {
  return <React.Fragment>{children}</React.Fragment>;
}
